// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__19beI","tab":"ProcedureTabs_tab__1bpMW"};